import type { PostInputMetaData } from '../../graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import { mapChannelVariantThread } from '../../channelVariantToCreatePostInput'
import { mapThread } from '../../mapThread'
import type { MapperContext } from '../../types'
import { clearable } from '../shared/clearable'
import type { ServiceMapperEntry } from '../types'

// Mastodon's spoiler text (content warning) from `channelData.mastodon`, plus
// the thread. Each is tri-stated via `clearable`: omitted on create, `null`
// on edit to clear it.
//
// `ctx.channelVariant` (when present) supplies both fields.
export function mapMastodon(
  draft: Draft,
  ctx: MapperContext,
): PostInputMetaData {
  const variant = ctx.channelVariant
  const spoilerText = variant
    ? variant.channelData?.mastodon?.spoilerText
    : draft.channelData?.mastodon?.spoilerText
  const thread = variant
    ? mapChannelVariantThread(variant.threadItems, 'mastodon')
    : mapThread(draft)

  return {
    mastodon: {
      spoilerText: clearable(spoilerText, ctx),
      thread: clearable(thread, ctx),
    },
  }
}

export const mastodon: ServiceMapperEntry = {
  mapper: mapMastodon,
}
